import { render } from "./Podani.vue?vue&type=template&id=794ad94e"
import script from "./Podani.vue?vue&type=script&lang=js"
export * from "./Podani.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\Arion\\SATRA\\SATRA_Inzenyring\\inzenyring\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__